import { render, staticRenderFns } from "./shepalinkGateway.vue?vue&type=template&id=5a8c7c4a"
import script from "./shepalinkGateway.vue?vue&type=script&lang=js"
export * from "./shepalinkGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports